(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // click-directive to show info about modifications 
    module.directive('agendaAppointmentShowModification', ['AppointmentDetailService', function (AppointmentDetailService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                id: '=', // appointment id
                appointment:'='
            }
        };
        return directive;

        function link(scope, element) {

            // click listener
            element.on('click', function () {
                show();
            });

            // show info
            function show() {
                AppointmentDetailService.modification(scope.id, scope.appointment)
            } // show

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        }
    }]);

})();